import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Minnesota = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Minnesota Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Mandatory disclosure of defects required.
        </Text>

        <Text style={styles.listItem}>
          2. Well Disclosure Certificate: Required if the property has a well.
        </Text>

        <Text style={styles.listItem}>
          3. Radon Disclosure: Required in residential transactions.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Known as 'Real Property Form No. 15,' this form outlines any
          problems with the property and must be given to the buyer.
        </Text>
      </View>
    </View>
  );
};

export default Minnesota;
